import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationGr from "./locales/gr.json";
import translationIT from "./locales/it.json";
import translationRS from "./locales/ru.json";
import translationSP from "./locales/sp.json";
import translationENG from "./locales/en.json";
import translationCN from "./locales/ch.json";
import translationFR from "./locales/fr.json";
import translationAR from "./locales/ar.json";

// the translations
const resources = {
  gr: {
    translation: translationGr,
  },
  it: {
    translation: translationIT,
  },
  rs: {
    translation: translationRS,
  },
  sp: {
    translation: translationSP,
  },
  en: {
    translation: translationENG,
  },
  cn: {
    translation: translationCN,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "fr");
}

i18n
  .use(initReactI18next) // passe i18n à react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "fr", // langue par défaut
    fallbackLng: "fr", // langue de secours si la langue détectée est indisponible
    keySeparator: false, // on ne veut pas utiliser de clé comme 'messages.welcome'
    interpolation: {
      escapeValue: false, // react s'occupe déjà de l'échappement des valeurs
    },
    detection: {
      // Optionnel : si tu ne veux pas que la détection automatique remplace la langue stockée
      order: ['localStorage', 'navigator'], // priorité à localStorage d'abord
      caches: ['localStorage'], // garder la langue dans localStorage
    },
  });

export default i18n;
